import { cn, formatTime, zoneHint } from '@/shared/lib'
import type { TranscriptSegment } from '../model/schema'

function formatMs(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

interface SegmentRowProps {
  segment: TranscriptSegment
  // Реплика смотрящего: выравнивается вправо, как свои сообщения в мессенджере.
  own?: boolean
  // Абсолютное время нуля таймлайна (ISO): с ним рядом с offset'ом показывается
  // фактическое время реплики в зоне устройства смотрящего.
  anchor?: string
}

export function SegmentRow({ segment, own = false, anchor }: SegmentRowProps) {
  const anchorMs = anchor ? new Date(anchor).getTime() : Number.NaN
  const wallTime = Number.isNaN(anchorMs)
    ? ''
    : formatTime(new Date(anchorMs + segment.startMs).toISOString())

  return (
    <div className={cn('flex', own ? 'justify-end' : 'justify-start')}>
      <div
        className={cn(
          'min-w-0 max-w-[min(46rem,90%)] rounded-card border px-4 py-2',
          own ? 'border-border-accent bg-bg-surface' : 'border-border-default bg-bg-elevated',
        )}
      >
        <p className={cn('label text-text-secondary', own && 'text-right')}>
          {own ? 'Вы' : segment.speakerName}
          {!own && segment.speakerUsername ? ` · @${segment.speakerUsername}` : ''}
        </p>
        <p className="text-sm text-text-primary">{segment.text}</p>
        {/* Таймкоды внутри пузыря, справа снизу: offset от начала + время в
            зоне смотрящего. Тег зоны стоит один раз над полотном реплик —
            в каждом пузыре он превратился бы в частокол. */}
        <p
          title={wallTime ? zoneHint() : undefined}
          className="mt-1 text-right font-mono text-[11px] tabular-nums text-text-tertiary"
        >
          {formatMs(segment.startMs)}
          {wallTime ? ` · ${wallTime}` : ''}
        </p>
      </div>
    </div>
  )
}
